import React from 'react';
import { Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import hero1 from '../../images/slider/slide-1.jpg';
import hero2 from '../../images/slider/slide-3.jpg';
import hero3 from '../../images/slider/slide-2.jpg';

const HeroSlider = () => {
    const { t } = useTranslation();

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    const renderSlide = (hero) => (
        <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero})` }}>
            <div className="gradient-overlay"></div>
            <div className="vector-1"></div>
            <div className="vector-2"></div>
            <div className="vector-3"></div>
            <div className="vector-4"></div>
            <div className="vector-5"></div>
            <div className="vector-6"></div>
            <div className="vector-7"></div>
            <div className="vector-8"></div>
            <div className="container">
                <div className="slide-content">
                    <div className="slide-title">
                        <h2>{t('hero.title')}</h2>
                    </div>
                    <div className="slide-text">
                        <p>{t('hero.text')}</p>
                    </div>
                    <div className="clearfix"></div>
                    <div className="slide-btns">
                        <Link onClick={ClickHandler} to="/service" className="theme-btn-s2">{t('hero.button')}</Link>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <section className="wpo-hero-slider wpo-hero-slider-s1" >
            <Swiper
                modules={[Navigation, A11y]}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                speed={1800}
                parallax={true}
                navigation
            >
                <SwiperSlide>{renderSlide(hero1)}</SwiperSlide>
                <SwiperSlide>{renderSlide(hero2)}</SwiperSlide>
                <SwiperSlide>{renderSlide(hero3)}</SwiperSlide>
            </Swiper>
        </section>
    );
};

export default HeroSlider;
